import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["template", "templates"];
import { useCallback, useEffect, useState } from 'react';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import AsyncSingleReportViewerFullPage from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerFullPage';
import { updateJourneyReportWithStageSelections } from 'reporting-enablement/components/reportEditors/PipelineStageOrderEditor/journeyStageUtils';
import { getPipelines } from '../../api/pipelinesApi';
import { getDefaultPipelineSelectedStages } from '../../utils/journeyGenerationUtils';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { isFailed, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { jsx as _jsx } from "react/jsx-runtime";
const getDefaultJourney = (template, pipelines) => {
  const defaultSelectedStages = getDefaultPipelineSelectedStages(template, pipelines);
  return updateJourneyReportWithStageSelections(template, defaultSelectedStages);
};
export const usePipelines = () => {
  const fetcher = useCallback(() => getPipelines(), []);
  return useAsyncFetcher({
    fetcher
  });
};
const GeneratedJourneySrv = _ref => {
  let {
      template,
      templates
    } = _ref,
    srvProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [srvTemplate, setSrvTemplate] = useState(null);
  const [additionalReports, setAdditionalReports] = useState(undefined);
  const asyncPipelines = usePipelines();
  useEffect(() => {
    if (isFailed(asyncPipelines)) {
      setSrvTemplate(template);
      setAdditionalReports(templates);
    }
    if (isSucceeded(asyncPipelines)) {
      const updatedSrvTemplate = isJourneyReport(template) ? getDefaultJourney(template, asyncPipelines.data) : template;
      setSrvTemplate(updatedSrvTemplate);
      if (templates) {
        const updatedTemplates = templates.map(aTemplate => isJourneyReport(aTemplate) ? getDefaultJourney(aTemplate, asyncPipelines.data) : aTemplate);
        setAdditionalReports(updatedTemplates);
      } else {
        setAdditionalReports(templates);
      }
    }
  }, [asyncPipelines, template, templates]);
  if (!srvTemplate) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncSingleReportViewerFullPage, Object.assign({}, srvProps, {
    report: srvTemplate,
    additionalReports: additionalReports
  }));
};
export default GeneratedJourneySrv;